import React from 'react';
import { Container } from '@mui/material';
import Testimonials from '../components/testimonials_pages/testimonials';
const TestimonialsPage = ()=>{
    return(
        <Container maxWidth={false}
            disableGutters
            sx={{
                // backgroundColor: "#000000",
                padding: {xs:"20px 20px",md:"80px 40px",lg:"80px 0px"},
            }}
        >
            <Testimonials />
        </Container>
    )
}
export default TestimonialsPage;